// This is a workaround to have the files from the folder @replai/replai-excalidraw/dist served
// This is needed to import files into the whiteboard, for example
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const context = require.context('@replai/replai-excalidraw/dist', true, /\.(js|woff2)$/);
context.keys().forEach(context);
